import type { FormDataSections } from '@/flows/types'

export type PersonalInfoData = NonNullable<FormDataSections['personalInfo']>
export type AddressInfoData = NonNullable<FormDataSections['addressInfo']>

export function createEmptyPersonalInfo(): PersonalInfoData {
  return {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    birthMonth: '',
    birthDay: '',
    birthYear: '',
    sexAssignedAtBirth: '',
  }
}

export function createEmptyAddressInfo(): AddressInfoData {
  return {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
  }
}

export function createInitialFlowFormData(): FormDataSections {
  return {
    personalInfo: createEmptyPersonalInfo(),
    addressInfo: createEmptyAddressInfo(),
    kitInfo: {
      kitId: '',
      consentAgreed: false,
    },
    pcpInfo: {
      hasPcp: null,
      needPcpHelp: null,
      pcpName: '',
      pcpFax: '',
      sendFaxToPcp: false,
      pcpAddressLine1: '',
      pcpAddressLine2: '',
      pcpCity: '',
      pcpState: '',
      pcpZipCode: '',
    },
  }
}
